module.exports = __webpack_public_path__ + "img/yuangong05.4d13ebea.jpg";